import BottomBar from './BottomBar.js';
import Logo from './Logo.js';
import ArticleTitle from './ArticleTitle.js';
import CallToActionButton from './CallToActionButton.js';
import Theme from './Theme.js';

/**
 * A component for displaying a BottomBar with Pro Page targeting.
 * @component
 * @returns {JSX.Element} The rendered JSX element.
 */

const BottomBarProTargeting = () => (
  <Theme>
    <BottomBar>
      <Logo />
      <ArticleTitle />
      <CallToActionButton />
    </BottomBar>
  </Theme>
);

BottomBarProTargeting.displayName = 'BottomBarProTargeting';

export default BottomBarProTargeting;
